export const mobileFloatingActionButtonClasses = [
  'max-md:!size-8',
  'max-md:!p-0',
  'max-md:!rounded-full',
  'max-md:[&>span]:!size-[22px]',
  'max-md:!border-0',
  'max-md:!bg-transparent',
  'max-md:!shadow-none',
  'max-md:transition-colors',
  'max-md:duration-150',
  'max-md:hover:!bg-[rgba(15,23,42,0.05)]',
  'max-md:active:!bg-[rgba(21,96,62,0.12)]',
  'max-md:active:!text-[#15603e]',
];

export const mobileContactOverlayClasses = [
  'max-md:!absolute',
  'max-md:!inset-x-auto',
  'max-md:!top-full',
  'max-md:!bottom-auto',
  'max-md:!mt-1',
  'max-md:ltr:!right-0',
  'max-md:rtl:!left-0',
  'max-md:!z-[120]',
];
